export enum TemplateTypeEnum {
	PROJECT = 'project',
	QUOTE = 'quote',
	QUOTE_CONFIG = 'quote_config'
}
